export default __webpack_public_path__ + "static/media/ADMIN_onboarding_04.ca146bfe.png";